// css
import '../htdocs/js/plugins/Remodal-1.1.0/dist/remodal.css';
import '../htdocs/js/plugins/Remodal-1.1.0/dist/remodal-default-theme.css';
import '../htdocs/css/style.css';
import '../htdocs/js/plugins/fancyBox-v2.1.5-0/source/jquery.fancybox.css';
import '../htdocs/js/plugins/Swiper-3.3.1/dist/css/swiper.min.css'



require('jquery.cookie');
require('jquery.maskedinput/src/jquery.maskedinput');

require('../htdocs/js/plugins/jquery.the-modal');
require('../htdocs/js/plugins/jquery.mousewheel-3.0.6.pack');
require('../htdocs/js/plugins/Remodal-1.1.0/dist/remodal');
require('../htdocs/js/plugins/fancyBox-v2.1.5-0/source/jquery.fancybox.pack');
require('../htdocs/js/plugins/Swiper-3.3.1/dist/js/swiper.jquery.min');

require('../htdocs/js/Form');
require('../htdocs/js/PNString');

require('../htdocs/js/PublicPage');


// WEBPACK FOOTER //
// ./main.js